export default __webpack_public_path__ + "static/Wineglass-Bay-15ff07b8f67b1443ef54317fddf56b05.jpg";